import { companyData } from '../../../global/change-company';

const _company = companyData.id;
const _maxRowHeight = 100;

let _k_upsideDownside = null;

const addMaxHeight = output => {
    return `<div style="max-height:${_maxRowHeight}px; overflow-y: auto;">${output}</div>`;
};

const multiTemplate = valueList => {
    let values = valueList.split(',');
    let output = '';
    $.each(values, function(index, value) {
        output += `<div class="tag tag-small">${value}</div>`;
    });
    return output;
};

const createGrid = () => {
    _k_upsideDownside = $('.js-overview.js-upside-downside')
        .kendoResourceEntry({
            dataSource: {
                schema: {
                    model: {
                        fields: {
                            Department: { editable: false },
                            Company: { editable: false },
                            ProjectNumber: { editable: false },
                            ProjectName: { editable: false },
                            Segment: { editable: false },
                            Total: { editable: true },
                            Values: { editable: true },
                        },
                    },
                },
                transport: {
                    read: {
                        url: '/Operations/ScheduleFiveOverview/UpsideDownsideData',
                        dataType: 'json',
                    },
                    parameterMap: function(data, type) {
                        let rs = {};
                        if (type === 'read') {
                            rs['company'] = _company;
                            return rs;
                        }
                    },
                },
                change(e) {},
                dataBound(e) {},
            },
            staticColumns: [
                {
                    field: 'ProjectNumber',
                    type: 'string',
                    title: 'Project Number',
                    width: 125,
                    editable: false,
                    sortable: true,
                    template: function(dataItem) {
                        if (dataItem.ProjectNumber) {
                            const output = multiTemplate(dataItem.ProjectNumber);
                            return addMaxHeight(output);
                        }
                    },
                },
                {
                    field: 'ProjectName',
                    type: 'string',
                    title: 'Project Name',
                    width: 185,
                    editable: false,
                    sortable: true,
                    template: function(dataItem) {
                        if (dataItem.ProjectName) {
                            const output = multiTemplate(dataItem.ProjectName);
                            return addMaxHeight(output);
                        }
                    },
                },
                {
                    field: 'Department',
                    type: 'string',
                    title: 'Job Department',
                    width: 250,
                    editable: false,
                    sortable: true,
                    template: function(dataItem) {
                        if (dataItem.Department) {
                            const output = multiTemplate(dataItem.Department);
                            return addMaxHeight(output);
                        }
                    },
                },
                {
                    field: 'Segment',
                    type: 'string',
                    title: 'Segment',
                    width: 80,
                    editable: false,
                    sortable: true,
                    template: function(dataItem) {
                        if (dataItem.Segment) {
                            const output = multiTemplate(dataItem.Segment);
                            return addMaxHeight(output);
                        }
                    },
                },
                {
                    field: 'ProjectManager',
                    type: 'string',
                    title: 'Project Manager',
                    width: 150,
                    editable: false,
                    sortable: true,
                    template: function(dataItem) {
                        if (dataItem.ProjectManager) {
                            const output = multiTemplate(dataItem.ProjectManager);
                            return addMaxHeight(output);
                        }
                    },
                },
                {
                    field: 'Total',
                    type: 'currency',
                    title: 'Total Upside/downside',
                    width: 150,
                    editable: false,
                },
            ],
            grid: {
                height: window.innerHeight * 0.75,
                scrollable: { virtual: 'rows' },
            },
            readonly: true,
            sortable: true,
            excel: {
                fileName: `ScheduleFiveUpsideDownside_${dateToYYYYMMDD(new Date())}.xlsx`,
                filterable: true,
            },
        })
        .data('kendoResourceEntry');
};

const dateToYYYYMMDD = date => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
};

export const getUpsideDownsideGrid = () => _k_upsideDownside?.grid;

export const refreshUpsideDownsideGrid = () => {
    _k_upsideDownside.grid.refresh();
};

export default function() {
    createGrid();
}
